export enum ChatbotStorage {
	CHAT_OPEN = 'isChatbotOpen',
	IS_CONVERSATIONAL_IRIS = 'irisConversational',
}
